export { contains, merge } from './static.js';
export * from './load-parse.js';
//# sourceMappingURL=index-browser.mjs.map